import Vue from 'vue'

import 'picturefill'
import 'intersection-observer'
import './baseComponents'
import vSlideToggle from './plugins/v-slide-toggle'
import VueScrollTo from 'vue-scrollto'
import vModal from './plugins/v-modal'
import TheModals from './components/TheModals'
import VueTelInput from 'vue-tel-input'
import VueIntercom from 'vue-intercom'
import TextareaAutosize from 'vue-textarea-autosize'
import {VLazyImagePlugin} from "v-lazy-image";
import {IS_PRODUCTION} from '@/constants/isProduction';


export function init({router, store}) {
  //SLIDE TOGGLE COMPONENT
  Vue.use(vSlideToggle)

  Vue.use(TextareaAutosize);

  //SLIDE TO
  Vue.use(VueScrollTo, {
    offset: -50
  })

  //V-MODAL
  Vue.use(vModal, {
    router,
    store,
    ModalsList: TheModals
  })


  //VUE-TEL-INPUT
  Vue.use(VueTelInput, {
    placeholder: "",
    required: false,
    autofocus: false,
    enabledCountryCode: false,
    validCharactersOnly: true,
    enabledFlags: true,
    preferredCountries: ['ua', 'ru', 'pl'],
    autocomplete: "off",
    mode: 'international',
    name: "phone",
    maxLen: 20,
    wrapperClasses: "input-phone",
    inputClasses: "input__input",
    dropdownOptions: {
      disabledDialCode: false
    },
    inputOptions: {
      showDialCode: true
    }
  })

  //INTERCOM
  if (!isRobotAgent && IS_PRODUCTION) {
    Vue.use(VueIntercom, {appId: 'l4gskfrx'})
  }

  //LAZY LOADING
  Vue.use(VLazyImagePlugin);

}
